export default "__VITE_ASSET__CrLCFfqp__"